/**
 * FIXME: PB-3948, merge with component in common.
 */
import { type InputElementProps } from '@admin/molecules/InputElement/InputElement';
import { EditIcon } from '@common/svg/icons/components/EditIcon';
import { MinusIcon } from '@common/svg/icons/components/MinusIcon';
import { XCircleIcon } from '@common/svg/icons/components/XCircleIcon';
import { type Action } from '@common/types/Action';
import { ActionsUtil } from '@common/utils/ActionsUtil';

import styles from './SectionHeader.module.scss';

export interface Props extends InputElementProps {
    title: string;
    actions: Action[];
}

export const SectionHeader = ({ actions, value, title }: Props) => {
    const action = ActionsUtil.format(actions)[0];
    let ChosenIcon;

    if (action.icon) {
        ChosenIcon = action.icon;
    } else {
        switch (action.id) {
            case 'delete':
                action.icon = XCircleIcon;
                break;
            case 'edit':
                action.icon = EditIcon;
                break;
            default:
                action.icon = MinusIcon;
                break;
        }
        ChosenIcon = action.icon;
    }

    return (
        <label className={styles.SectionHeader}>
            {title}
            {action && typeof value !== 'undefined' ? (
                <span className={styles.action}>
                    <ChosenIcon
                        key={action.id}
                        onClick={() => {
                            if (action.callback) action.callback(value);
                        }}
                    />
                </span>
            ) : null}
        </label>
    );
};
